import { Component, Input } from '@angular/core';
import { DialogService } from 'src/app/core/dialog.service';
import { SharedHelpDialogComponent } from 'src/app/shared/shared-help-dialog/shared-help-dialog.component';

@Component({
  selector: 'app-plain-toolbar',
  templateUrl: './plain-toolbar.component.html',
  styleUrls: ['./plain-toolbar.component.scss'],
})
export class PlainToolbarComponent {
  @Input() icon_button_class: string = 'hmn-icon__button-main';

  constructor(private dialog_service: DialogService) {}

  onHelpClick(): void {
    this.dialog_service.openDialog(SharedHelpDialogComponent);
  }
}
